import { CAMPAIGN as BASE } from "../route";
import { HashTagMenu } from "./menu";

export const HASHTAGS = BASE.sub("/hashtags");
export const HASHTAG = BASE.sub("/hashtags/:hashTagId", undefined, {
  components: { menu: HashTagMenu },
});
